import React from "react";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import { Form, Row, Col, Input, Button } from "antd";
import ContactUsModal from "./ContactUsModal";
import { InstagramOutlined, TwitterOutlined } from "@ant-design/icons";

const Footer = (props) => {
  let menuProps = props.footerNavLinks ? props.footerNavLinks : [];
  let menuLinks = [{ title: "HOME", path: "/" }, ...menuProps].map(
    (item, i) => {
      return (
        <NavLink
          key={i}
          activeClassName="active"
          to={item.path}
          className="nav-link"
          style={{ fontSize: 14, fontWeight: "bold" }}
        >
          {item.title}
        </NavLink>
      );
    }
  );

  const handleSubscribe = () => {};

  return (
    <Row className="Footer">
      <ContactUsModal
        showContact={props.showContact}
        changeShowContact={props.changeShowContact}
      />
      <Col
        xs={24}
        className="inner--footer"
        style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}
      >
        {menuLinks}
      </Col>

      <Col className="flex-col" style={{ gap: 4 }}>
      <div>
        <button
          onClick={props.changeShowContact}
          style={{
            background: "unset",
            border: "unset",
            cursor: "pointer",
            margin: 0,
            padding: 0
          }}
        >
          Contact Us
        </button>
        </div>
        <Link to="/advertise">Advertise</Link>
        <Link to="/termsofservice">Terms of Service</Link>
        <Link to="/privacypolicy">Privacy Policy</Link>
        <Link to="/cookiepolicy">Cookie Policy</Link>
        <Link to="/communityguidelines">Community Guidelines</Link>
        {/* <Link to="/">Cookie Settings</Link> */}
        <Link to="/donotsellmypersonalinfo">Do Not Sell/Share My Personal Information</Link>
        <Link to="/californianotice">California Notice at Collection</Link>
      </Col>

      <Col>
        <div className="blue title">SUBSCRIBE</div>
        <p style={{ paddingRight: "20px" }}>
          Subscribe to updates and newsletters to get the latest news and more.
        </p>
        <Form onSubmit={handleSubscribe}>
          <Row>
            <Col xs={16} sm={18}>
              <Form.Item
                style={{ textAlign: "left" }}
                name="email"
                rules={[
                  {
                    type: "email",
                    required: true,
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="enter email address"
                  size="large"
                  onChange={props.handleEmailChange}
                />
              </Form.Item>
            </Col>
            <Col xs={4} sm={4} offset={1}>
              <Button
                htmlType="submit"
                className="btn-bordered"
                style={{ width: 85, height: 40 }}
                type="text"
              >
                GO
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>



      <Col className="flex-row" style={{ gap: 8 }}>
        <Button
          style={{ borderColor: "#bfbfbf" }}
          className="btn-bordered"
          href=""
          icon={<InstagramOutlined />}
        />
        <Button
          style={{ borderColor: "#bfbfbf" }}
          className="btn-bordered"
          href=""
          icon={<TwitterOutlined />}
        />
      </Col>

      <Col
  xs={24}
  md={24}
  style={{
    textAlign: "center",
    borderTop: "1px solid rgb(233, 233, 233)",
    paddingTop: 16,
  }}
>
  <div style={{ 
    fontSize: 12, 
    lineHeight: 1.7, 
    color: '#666',
    maxWidth: 1000,
    margin: '0 auto',
    padding: '0 20px'
  }}>
    <p style={{ marginBottom: 12, fontWeight: 500, color: '#333' }}>
      © 2025 No Cap Vote. All Rights Reserved.
    </p>
    
    <p style={{ marginBottom: 10 }}>
      No Cap Vote is not liable for content on external websites, which are linked for reference purposes only. 
      Your use of this website indicates acceptance of our Terms of Service and Privacy Policy. 
      No Cap Vote may receive compensation for featured products or services and use tools for functionality, 
      personalization, analytics, marketing, and advertising.
    </p>
    
    <p style={{ margin: 0 }}>
      Our website may contain links to third-party websites or display content provided by third parties. 
      Such links and content are provided for convenience, reference, and informational purposes only. 
      The inclusion of any third-party link or content does not constitute or imply any endorsement, 
      approval, sponsorship, or affiliation with our organization, or with our content, products, services, 
      causes, or viewpoints. We do not control, and assume no responsibility for the content, accuracy, 
      availability, policies, or practices of any third-party websites or materials. Access to, and use of, 
      third party content or websites is at your own risk. Such links do not authorize the use of any 
      third-party content for improper commercial purposes or in any manner that is unlawful, misleading, 
      or harmful. To the fullest extent permitted by applicable law, we disclaim all liability arising from 
      or related to the use of, or reliance on, any third-party content or websites. Third parties reserve 
      the right to withdraw permission for any link to, or from, our website at any time and at their sole 
      discretion.
    </p>
  </div>
</Col>
    </Row>
  );
};

export default Footer;
